export default __webpack_public_path__ + "static/media/arrow_icon.10cc7dd9.svg";